<template>
    <div class="page-content">

        <div id="careers" class="section grow">
            <div class="overlay opacity-50"></div>
            <lottie-player
                autoplay
                loop
                mode="normal"
                preserveAspectRatio="xMidYMid slice"
                src="https://cdn.sleepjar.com/sleepsounds/images/backgrounds/7x3/animated/simple/json/StarryMountains.json"
                class="bg-lottie-player"
            />
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">

                        <div v-if="os == 'android'">
                            <h1 class="title color-white">Uh-oh!</h1>
                            <p class="lead mb-5">Allow Sleep Jar for Android to use deep links then try again.</p>
                            <div class="d-inline-block text-left">
                                <div class="row">
                                    <ol>
                                        <li>Long press the app icon for Sleep Jar</li>
                                        <li>Press "app info"</li>
                                        <li>Tap "open by default"</li>
                                        <li>Tap "add link"</li>
                                        <li>Check "sleepjar.com"</li>
                                        <li>Press "add"</li>
                                        <li>Try linking to Alexa again!</li>
                                    </ol>
                                </div>
                            </div>
                            <p class="lead mt-5"><small class="opacity-50">These steps are only required on Firebase beta builds of Sleep Jar for Android.</small></p>
                        </div>
                        <div v-else-if="os == 'ios' && linkCode && linkState">
                            <h1 class="title color-white">Verifying connection...</h1>
                            <p class="lead mt-5">Tap "yes" if you're prompted to open Sleep Jar.</p>
                        </div>
                        <div v-else-if="os == 'ios'">
                            <h1 class="title color-white">Uh-oh!</h1>
                            <p class="lead mb-5"><i>Link with Alexa</i> must be started from within the Sleep Jar iOS app.</p>
                            <div class="d-inline-block text-left">
                                <div class="row">
                                    <ol>
                                        <li>Install <a :href="$root.app_link.ios" target="_blank" class="underline">Sleep Jar for iPhone</a></li>
                                        <li>Open Sleep Jar on your iPhone</li>
                                        <li>Navigate to the "Home" tab</li>
                                        <li>Tap the settings icon in the top right</li>
                                        <li>Tap "Link with Alexa"</li>
                                        <li>Follow the on-screen prompts</li>
                                    </ol>
                                </div>
                            </div>
                            <p class="lead mt-5"><small class="opacity-50">If you're still having trouble linking after following these steps, please contact us.</small></p>
                        </div>
                        <div v-else>
                            <h1 class="title color-white">Uh-oh!</h1>
                            <p class="lead mb-5">You've arrived to this page by mistake.</p>
                            <p class="lead mb-5">Follow these steps to link your Sleep Jar account to Alexa:</p>
                            <div class="d-inline-block text-left">
                                <div class="row">
                                    <ol>
                                        <li>Open Sleep Jar on your Android or iPhone</li>
                                        <li>Navigate to the "Home" tab</li>
                                        <li>Tap the settings icon in the top right</li>
                                        <li>Tap "Link with Alexa"</li>
                                        <li>Follow the on-screen prompts</li>
                                    </ol>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    data () {
        return {
        };
    },
    name: 'alexa-link-result',
    metaInfo: {
        title: 'Link to Alexa',
        meta: [
            {
                'name': 'description',
                'property': 'og:description',
                'content': 'Link your Sleep Jar account to Amazon Alexa for the best cross-platform experience.'
            }
        ]
    },
    methods: {
    },
    computed: {
        os: function(){
            const ua = (navigator.userAgent || "").toLowerCase();
            if(ua.includes("ios") || ua.includes("iphone")) return "ios";
            if(ua.includes("android")) return "android";
            if(ua.includes("win")) return "windows";
            if(ua.includes("mac")) return "mac";
            if(ua.includes("linux")) return "linux";
            return null;
        },
        linkCode: function(){
            return this.$route.query.code;
        },
        linkState: function(){
            return this.$route.query.state;
        }
    },
    components: {
    },
    mounted(){
        if(this.os == "ios" && this.linkCode && this.linkState){
            window.location.href = `sleepjar://alexa/link/result?code=${this.linkCode}&state=${this.linkState}`;
        }
    }
}
</script>
